module.exports = __webpack_public_path__ + "static/img/zombs1.ff2b151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/image-benefit/zombs1.png
// module id = C83o
// module chunks = 38